import React from 'react';
import { Link } from 'react-router-dom';

import { FiPlus } from 'react-icons/fi';
import { TITLE_BUTTON_ADD, TITLE_BUTTON_ADD_EN, URL_ADD_THREAD } from '../../utils/common/constant';
import { SettingConsumer } from '../../contexts/settingContext';
import Button from '../styled/button/Button';

const AddCircleButton = () => {
  return (
    <SettingConsumer>
      {
        ({ locale }) => {
          const titleButtonAdd = locale === 'id' ? TITLE_BUTTON_ADD : TITLE_BUTTON_ADD_EN;
          return (
            <Link to={URL_ADD_THREAD}>
              <Button type="button" aria-label={titleButtonAdd} title={titleButtonAdd}><FiPlus /></Button>
            </Link>
          );
        }
      }
    </SettingConsumer>
  );
};

export default AddCircleButton;
